import { compose } from "redux";
import times from "lodash/times";
import isNil from "lodash/isNil";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";
import { reduxForm } from "redux-form/immutable";
import { withStyles } from "@material-ui/core/styles";

import { BasePageTitle } from "altus-ui-components";

import {
  GroupMapper,
  bookingSystemTypeToString,
} from "features/planner/planner.mappers";

import {
  addHeliReportItem,
  heliReportGroupOnLoad,
} from "features/planner/report/report.actions";

import { getFormValueFromState } from "app/app.selectors";
import ReadOnlyField from "app/components/form/ReadOnlyField";
import { getGroupFromState } from "features/planner/planner.selectors";
import { HeliReportMapper } from "features/planner/report/report.mappers";
import { HELI_REPORT_FORM } from "features/planner/report/report.constants";
import { getHeliReportGroupFromState } from "features/planner/report/report.selectors";
import ShoreOffshoreBoundRow from "features/planner/report/helicopter/components/ShoreOffshoreBoundRow";
import HeliReportResponsible from "features/planner/report/helicopter/components/HeliReportResponsible";
import HeliReportAddNewItemRow from "features/planner/report/helicopter/components/HeliReportAddNewItemRow";
import ShoreOffshoreBoundHeader from "features/planner/report/helicopter/components/ShoreOffshoreBoundHeader";
import ShoreOffshoreBoundColumnDescriptions from "features/planner/report/helicopter/components/ShoreOffshoreBoundColumnDescriptions";

class HeliReportGroup extends PureComponent {
  componentDidMount() {
    const { dispatchHeliReportGroupOnLoad, groupId } = this.props;

    if (groupId) {
      dispatchHeliReportGroupOnLoad(groupId);
    }
  }

  render() {
    const {
      group,
      groupId,
      classes,
      maxIndex,
      heliReport,
      dispatchAddHeliReportItem,
    } = this.props;

    if (!group) return null;

    return (
      <Grid className={classes.root} container spacing={4}>
        <Grid item>
          <BasePageTitle title={group.get("name")} />
        </Grid>
        <Grid container item>
          <Grid container item className={classes.subRoot}>
            <Grid container className={classes.heading}>
              <Grid container spacing={2}>
                <Grid item>
                  {!isNil(group.get("bookingSystemType")) && (
                    <ReadOnlyField
                      margin="none"
                      label="Booking System"
                      input={{
                        value: bookingSystemTypeToString(
                          group.get("bookingSystemType"),
                        ),
                      }}
                    />
                  )}
                </Grid>
                <Grid item>
                  {group.get("bookingContact") && (
                    <ReadOnlyField
                      margin="none"
                      label="Booking Contact"
                      input={{
                        value: group.get("bookingContact"),
                      }}
                    />
                  )}
                </Grid>
                <Grid item>
                  {group.get("bookingPhone") && (
                    <ReadOnlyField
                      margin="none"
                      label="Booking Phone"
                      input={{
                        value: group.get("bookingPhone"),
                      }}
                    />
                  )}
                </Grid>
                <Grid item>
                  {group.get("bookingEmail") && (
                    <ReadOnlyField
                      margin="none"
                      label="Booking Email"
                      input={{
                        value: group.get("bookingEmail"),
                      }}
                    />
                  )}
                </Grid>
                <Grid item>
                  {group.get("airport") && (
                    <ReadOnlyField
                      margin="none"
                      label="Heliport"
                      input={{
                        value: group.get("airport"),
                      }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <ShoreOffshoreBoundHeader />
            <ShoreOffshoreBoundColumnDescriptions
              bookingSystemType={heliReport.get("bookingSystemType")}
            />
            {times(maxIndex + 1, index => (
              <ShoreOffshoreBoundRow key={index} index={index} />
            ))}
          </Grid>
          {groupId && (
            <HeliReportAddNewItemRow onClick={dispatchAddHeliReportItem} />
          )}
        </Grid>
        <Grid
          item
          container
          justifyContent="space-between"
          className={classes.responsibleContainer}
        >
          <Grid item>
            <HeliReportResponsible
              responsible={heliReport.get("responsible")}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

HeliReportGroup.defaultProps = {
  heliReport: HeliReportMapper.initial(),
  group: GroupMapper.initial(),
};

const styles = theme => ({
  icon: {
    width: theme.altus.mediumRow.height,
    height: theme.altus.mediumRow.height,
    minWidth: theme.altus.mediumRow.height,
  },
  oilRigIcon: {
    width: "2em",
    height: "2em",
  },
  subRoot: {
    borderTop: "none",
  },
  responsibleContainer: {
    pageBreakInside: "avoid",
  },
  root: {
    display: "block",
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  heading: {
    marginBottom: theme.spacing(1.5),
  },
});

export default compose(
  connect(
    (state, { groupId }) => ({
      maxIndex: getFormValueFromState(
        state,
        HELI_REPORT_FORM.ID,
        HELI_REPORT_FORM.MAX_INDEX,
      ),
      group: groupId ? getGroupFromState(state, groupId) : undefined,
      heliReport: groupId
        ? getHeliReportGroupFromState(state, groupId)
        : undefined,
    }),
    {
      dispatchAddHeliReportItem: addHeliReportItem,
      dispatchHeliReportGroupOnLoad: heliReportGroupOnLoad,
    },
  ),
  reduxForm({
    form: HELI_REPORT_FORM.ID,
  }),
  withStyles(styles),
)(HeliReportGroup);
